const roles = [
  {
    id: 'isAdmin',
    name: 'ADMIN',
    nomination: ['isAdmin', 'isUser'],
    privileges: {
      MANAGE_PROFILE_ROLE: true,
      MANAGE_COMPANY_USER: true,
      MANAGE_COMPANY_USER_ROLE: true,
      MANAGE_COMPANY_BILLING: true,
      DELETE_PHOTO: true,
    },
  },
  {
    id: 'isUser',
    name: 'USER',
    nomination: ['isUser'],
    privileges: {
      MANAGE_PROFILE_ROLE: false,
      MANAGE_COMPANY_USER: false,
      MANAGE_COMPANY_USER_ROLE: false,
      MANAGE_COMPANY_BILLING: false,
      DELETE_PHOTO: false,
    },
  },
];

export default roles;
